//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as mailDraftAction from '../action/mailDraftAction';
import * as helpAction from '../action/helpAction';
//Func
import atom2datetime from '../func/atom2datetime';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//Menu
import MenuMailbox from './MenuMailbox';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {

  constructor(props) {
    document.title = '下書きメール - パートナーズ';
    super(props);
  	this.state = {
      mailDraftDelAnchor: null,
      mailDraftDelPic: null,
  	}
  }

  componentDidMount() {
    document.title = '下書きメール - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.mailDraft.datetime) {
      this.props.mailDraftListGet(1);
      window.scrollTo(0, 0);
    }
  }



  _onPaging(page) {
    this.props.mailDraftListGet(page);
    window.scrollTo(0, 0);
  }

	_renderList = (value, index, arr) => {
		return (
      <div
        key={index}
        style={{
          padding:'5px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': ''
        }}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
          }}
        >

          <div
            onClick={ () => this.props.history.push({pathname: '/mailbox/talk/' + value.userdata_id_code, referrer: '/mailbox/draft/'}) }
            style={{padding:'5px',cursor:'pointer'}}
          >
            <PartUserMainImg
              mainImg={value.userdata_mainImg}
              width={'40px'}
              height={'40px'}
              radius={'50%'}
            />
          </div>
          <div
            onClick={ () => this.props.history.push({pathname: '/mailbox/talk/' + value.userdata_id_code, referrer: '/mailbox/draft/'}) }
            style={{padding:'5px',cursor:'pointer'}}
          >
            <div>
              <PartUserName
                data={{
                  name: value.userdata_name,
                  sex: value.userdata_sex,
                  size: '1.2em',
                }}
              />
              &nbsp;
              <span style={{color:'#333'}}>{value.userdata_age}才 {value.userdata_prof_region}</span>
            </div>
            <div style={{color:'#666'}}>
              {atom2datetime(value.mail_draft_datetime_atom, 'DT')}
            </div>
            <div
              style={{
                color:'#666',
                overflow:'hidden',
                height:'3.2em',
                lineHeight:'1.6',
              }}
            >
              {value.mail_draft_text.substr(0, 100)}
            </div>
          </div>

          <div style={{marginLeft: 'auto'}}>
            <IconButton
              onClick={ (event) => this.setState({mailDraftDelPic:value.userdata_id_code, mailDraftDelAnchor:event.currentTarget}) }
            >
              <MoreVertSharpIcon
                style={{fontSize:'1.2em',color:'#999'}}
              />
            </IconButton>
          </div>
  			</div>

      </div>
		);
	};



	render() {
		return (
      <div>
        <div style={{maxWidth:'480px', margin:'auto'}}>
          <MenuMailbox />
        </div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '5px',
            }}
          >
            <div>
            </div>

            <div>
              <span style={{color:'#666'}}>ページ{this.props.mailDraft.page}</span>

              <IconButton
                onClick={ () => this.props.mailDraftListGet(1) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>
          {
            (this.props.mailDraft.datetime) && (
              (this.props.mailDraft.list.length > 0) ? (
                <div>

                  <Box boxShadow={2} style={{background:'#FFF'}}>
                    {
            					this.props.mailDraft.list.map(
                      	(value, index, arr) => this._renderList(value, index, arr)
                    	)
            				}
                  </Box>

                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.mailDraft.page}
                      isNext={this.props.mailDraft.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>
                </div>
              ): (
                <div>
                  <h2 align='center' style={{padding:'30px 0px'}}>
                    <span className='i-b'>下書きメールは</span>
                    <span className='i-b'>ありませんでした</span>
                  </h2>
                </div>
              )
            )
          }


        </div>

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','mail-draft') }
          >
            「下書きメール」とは？
          </Button>
        </div>

        <Menu
          anchorEl={this.state.mailDraftDelAnchor}
          keepMounted
          open={(this.state.mailDraftDelPic)? true: false}
          onClick={ () => this.setState({mailDraftDelPic: null}) }
        >
          <MenuItem
            onClick={ () => {
              this.props.mailDraftDel(this.state.mailDraftDelPic);
              this.setState({mailDraftDelAnchor:null, mailDraftDelPic:null});
            }}
          >
            <div>
              下書きメールを削除する
            </div>
          </MenuItem>
        </Menu>
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    mailDraft: state.mailDraft,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...mailDraftAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
